import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../layout";
import ExamTip from "../views/examTip";
import Test from "../views/test";
import TestResult from "../views/testResult";
import { menuRoutes } from "./menuRoutes";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Layout,
    children: [...menuRoutes],
  },
  {
    path: "/examTip/:id",
    name: "考前提示",
    component: ExamTip,
  },
  {
    path: "/test/:id",
    name: "test",
    component: Test,
  },
  {
    path: "/testResult/:id",
    name: "testResult",
    component: TestResult,
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    // 登录校验
    next("/login?redirectUrl=" + to.path);
    return;
  }
  window.scrollTo({ top: 0 });
  next();
});

export default router;
